import script from "./bonusProgramInfoPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./bonusProgramInfoPopover.vue?vue&type=script&setup=true&lang=js"

import "./bonusProgramInfoPopover.vue?vue&type=style&index=0&id=dba54ec6&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dba54ec6"]])

export default __exports__